import { useTranslation } from 'react-i18next';

interface FormationObjectivesProps {
  objectives: string[];
}

export function FormationObjectives({ objectives }: FormationObjectivesProps) {
  const { t } = useTranslation('formations');
  // SVG personnalisés pour les objectifs
  const customIcons = [
    // 1. Cible / Target
    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="40" fill="#F06C6E" opacity="0.1"/>
      <circle cx="50" cy="50" r="40" fill="none" stroke="#F06C6E" strokeWidth="2.5"/>
      <circle cx="50" cy="50" r="28" fill="none" stroke="#F06C6E" strokeWidth="2.5"/>
      <circle cx="50" cy="50" r="16" fill="none" stroke="#F06C6E" strokeWidth="2.5"/>
      <circle cx="50" cy="50" r="6" fill="#F06C6E"/>
      <path d="M 50 10 L 50 30" stroke="#F06C6E" strokeWidth="2.5" strokeLinecap="round"/>
      <path d="M 50 70 L 50 90" stroke="#F06C6E" strokeWidth="2.5" strokeLinecap="round"/>
      <path d="M 10 50 L 30 50" stroke="#F06C6E" strokeWidth="2.5" strokeLinecap="round"/>
      <path d="M 70 50 L 90 50" stroke="#F06C6E" strokeWidth="2.5" strokeLinecap="round"/>
    </svg>,

    // 2. Graphique croissant / Growth
    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <path d="M 15 80 L 15 85 L 85 85" fill="none" stroke="#F06C6E" strokeWidth="2.5" strokeLinecap="round"/>
      <rect x="20" y="65" width="10" height="15" fill="#F06C6E" opacity="0.3" rx="2"/>
      <rect x="35" y="55" width="10" height="25" fill="#F06C6E" opacity="0.5" rx="2"/>
      <rect x="50" y="40" width="10" height="40" fill="#F06C6E" opacity="0.7" rx="2"/>
      <rect x="65" y="25" width="10" height="55" fill="#F06C6E" rx="2"/>
      <path d="M 25 68 L 40 58 L 55 43 L 70 28 L 82 18" fill="none" stroke="#F06C6E" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="82" cy="18" r="4" fill="#F06C6E"/>
      <path d="M 75 15 L 82 18 L 79 25" fill="none" stroke="#F06C6E" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>,

    // 3. Trophée / Achievement
    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="50" cy="85" rx="20" ry="4" fill="#F06C6E" opacity="0.2"/>
      <rect x="45" y="70" width="10" height="15" fill="#F06C6E" opacity="0.4" rx="1"/>
      <rect x="38" y="80" width="24" height="8" fill="#F06C6E" rx="2"/>
      <path d="M 35 25 Q 35 45 50 50 Q 65 45 65 25 L 65 20 Q 65 15 60 15 L 40 15 Q 35 15 35 20 Z"
            fill="#F06C6E" opacity="0.15" stroke="#F06C6E" strokeWidth="2.5"/>
      <circle cx="50" cy="35" r="12" fill="none" stroke="#F06C6E" strokeWidth="2.5"/>
      <path d="M 50 30 L 52 36 L 58 36 L 53 40 L 55 46 L 50 42 L 45 46 L 47 40 L 42 36 L 48 36 Z" fill="#F06C6E"/>
      <path d="M 30 25 Q 28 30 25 35 Q 22 40 22 45" fill="none" stroke="#F06C6E" strokeWidth="2" strokeLinecap="round"/>
      <path d="M 70 25 Q 72 30 75 35 Q 78 40 78 45" fill="none" stroke="#F06C6E" strokeWidth="2" strokeLinecap="round"/>
    </svg>,

    // 4. Check / Validation
    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="35" fill="#F06C6E" opacity="0.15"/>
      <circle cx="50" cy="50" r="35" fill="none" stroke="#F06C6E" strokeWidth="3"/>
      <path d="M 30 50 L 45 65 L 72 35" fill="none" stroke="#F06C6E" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="30" cy="50" r="3" fill="#F06C6E"/>
      <circle cx="45" cy="65" r="3" fill="#F06C6E"/>
      <circle cx="72" cy="35" r="3" fill="#F06C6E"/>
    </svg>,

    // 5. Éclair / Energy
    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <path d="M 55 15 L 35 50 L 50 50 L 45 85 L 75 40 L 55 40 Z"
            fill="#F06C6E" opacity="0.2" stroke="#F06C6E" strokeWidth="2.5" strokeLinejoin="round"/>
      <path d="M 55 15 L 35 50 L 50 50 L 45 85"
            fill="none" stroke="#F06C6E" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M 45 85 L 75 40 L 55 40 L 55 15"
            fill="none" stroke="#F06C6E" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="50" cy="50" r="8" fill="#F06C6E" opacity="0.3"/>
    </svg>,

    // 6. Ampoule / Idea
    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="50" cy="40" rx="20" ry="25" fill="#F06C6E" opacity="0.15"/>
      <path d="M 35 35 Q 30 45 30 55 Q 30 60 32 63 L 35 68 Q 35 70 37 70 L 63 70 Q 65 70 65 68 L 68 63 Q 70 60 70 55 Q 70 45 65 35 Q 60 25 50 25 Q 40 25 35 35 Z"
            fill="none" stroke="#F06C6E" strokeWidth="2.5"/>
      <rect x="42" y="70" width="16" height="8" fill="#F06C6E" opacity="0.3" rx="2"/>
      <rect x="45" y="78" width="10" height="3" fill="#F06C6E" rx="1"/>
      <line x1="50" y1="45" x2="50" y2="55" stroke="#F06C6E" strokeWidth="2" strokeLinecap="round"/>
      <line x1="45" y1="50" x2="55" y2="50" stroke="#F06C6E" strokeWidth="2" strokeLinecap="round"/>
      <path d="M 25 30 L 20 25" stroke="#F06C6E" strokeWidth="2" strokeLinecap="round"/>
      <path d="M 75 30 L 80 25" stroke="#F06C6E" strokeWidth="2" strokeLinecap="round"/>
      <path d="M 30 18 L 28 12" stroke="#F06C6E" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ];

  return (
    <section className="py-24 bg-transparent">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <h2 className="text-3xl font-heading font-extrabold text-aspexit-black mb-3">
              {t('objectives.title')}
            </h2>
            <p className="text-aspexit-gray text-lg max-w-2xl mx-auto">
              {t('objectives.subtitle')}
            </p>
          </div>

          {/* Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {objectives.map((objective, index) => {
              const customIcon = customIcons[index % customIcons.length];
              return (
                <div
                  key={index}
                  className="bg-white rounded-xl border-2 border-border p-6 hover:shadow-lg hover:border-aspexit-red/40 transition-all hover:-translate-y-1"
                >
                  {/* Icon */}
                  <div className="w-14 h-14 bg-aspexit-red/10 rounded-xl flex items-center justify-center mb-4 p-2">
                    {customIcon}
                  </div>

                  {/* Objective text */}
                  <p className="text-aspexit-black leading-relaxed font-medium">
                    {objective}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
